import { COMPONENT_NAME_PREFIX } from '../constants';
var elementName = COMPONENT_NAME_PREFIX + "file-picker";
var attributes = {
    ACCEPT: 'accept',
    MAX_SIZE: 'max-size',
    CAPTURE: 'capture',
    MULTIPLE: 'multiple',
    DISABLED: 'disabled',
    COMPACT: 'compact',
    BORDERLESS: 'borderless'
};
var classes = {
    HIGHLIGHT: 'highlight',
    DISABLED: 'disabled',
    COMPACT: 'compact',
    BORDERLESS: 'borderless'
};
var ids = {
    CONTAINER: 'container',
    BUTTON: 'button',
    INPUT: 'input',
};
var selectors = {
    CONTAINER: '#container',
    BUTTON: '#button',
    INPUT: '#input',
    BUTTON_SLOT: '#button-slot',
};
var events = {
    FILES_CHANGED: COMPONENT_NAME_PREFIX + "file-picker-change",
};
export var FILE_PICKER_CONSTANTS = {
    elementName: elementName,
    attributes: attributes,
    classes: classes,
    ids: ids,
    selectors: selectors,
    events: events,
};
